module.exports = __webpack_public_path__ + "img/yalda_no.2a2576e8.png";